import { cn } from "@/utils/cn";
import { useLocation, useNavigate } from "react-router-dom";

export const MenuNavItem = ({
  to,
  children,
  onSelect,
}: {
  to: string;
  children: React.ReactNode;
  onSelect: () => void;
}) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const active = pathname === to || pathname.startsWith(`${to}/`);

  return (
    <button
      type="button"
      aria-current={active ? "page" : undefined}
      className={cn(
        "flex w-full items-center px-3 py-2 text-sm rounded-[3px] hover:bg-zinc-100 transition-colors text-left cursor-pointer",
        active ? "text-zinc-900 font-medium" : "text-zinc-700",
      )}
      onClick={() => {
        onSelect();
        navigate(to);
      }}
    >
      {children}
    </button>
  );
};
